var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showHeader),expression:"!showHeader"}]}),_c('router-view',{class:['page-wrap',_vm.page_bg]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }